import {
  GET_ADMINISTRATIVE_DISTRICTS,
  GET_ADMINISTRATIVE_DISTRICTS_ALL,
  GET_RAYON_BY_OBLAST,
} from "../../types";

const initialState = {
  administrativeDistrictsAll: [],
  administrativeDistricts: {},
  rayonByOblast: [],
};

export const administrativeDistrictsReducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case GET_ADMINISTRATIVE_DISTRICTS_ALL:
      return (() => ({
        ...state,
        administrativeDistrictsAll: action.data,
      }))();
    case GET_ADMINISTRATIVE_DISTRICTS:
      return (() => ({
        ...state,
        administrativeDistricts: action.data,
      }))();
    case GET_RAYON_BY_OBLAST:
      return (() => ({
        ...state,
        rayonByOblast: action.data,
      }))();
    default:
      return state;
  }
};
